import React from 'react';

import { t } from '../../services/i18nService';
import settingsReader from '../../store/readHelpers/SettingsReader';
import sessionReader from '../../store/readHelpers/SessionReader';
import deliveringService from '../../services/DeliveringService';
import OptionsTopBar from './OptionsTopBar';
import Confirmation from './Confirmation';
import { getA11yAttributesV2 } from '../../services/a11yIIBScreenReaderService';

import styles from './options.scss';

class OptionsDeliverBlank extends React.PureComponent {
    requiresInvigilatorPassword = () => {
        return settingsReader.isInvigilatorPasswordRequiredForDeliverBlank() &&
            sessionReader.testUsesInvigilatorPassword();
    };

    actionHandler = () => {
        deliveringService.deliverBlank();
    };

    render() {
        const text = t('options.deliverBlankText');
        const mainButtonText = t('options.deliverBlankButtonText');
        const requireInvigilatorPassword = this.requiresInvigilatorPassword();

        return (
            <div>
                <OptionsTopBar
                    title={t('options.deliverBlank')}
                    showOptionsButton
                    exitButtonProps={getA11yAttributesV2({ 'aria-label': t('options.closeOptionsMenu') })}
                    optionsButtonProps={getA11yAttributesV2({ 'aria-label': t('options.backToOptionsList') })}
                />
                <div className={styles.mainContentArea} role="main">
                    <Confirmation
                        text={text}
                        mainButtonText={mainButtonText}
                        actionHandler={this.actionHandler}
                        requireInvigilatorPassword={requireInvigilatorPassword}
                        {...getA11yAttributesV2({
                            confirmButtonA11y: { 'role': 'button', 'aria-label': t('options.deliverBlankButtonText') },
                            cancelButtonA11y: { 'aria-label': t('generic.cancel') },
                        })}
                    />
                </div>
            </div>
        );
    }
}

export default OptionsDeliverBlank;
